import {Component, Input, OnInit, Optional} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from '../../../../infrastructure/decorators/auto-unsubscribe.decorator';
import {VccDailySummaryReportFilterResult} from '../../model/vcc-daily-summary-report-filter-result';
import {MerchantsService} from 'src/infrastructure/merchants/service/merchants.service';
import {Merchant} from 'src/app/dashboard/model/merchant-guid';


@AutoUnsubscribe()
@Component({
    selector: 'vcc-daily-summary-reports-filter-modal',
    templateUrl: './vcc-daily-summary-reports-filter-modal.component.html',
    standalone: false
})
export class VccDailySummaryReportFilterModalComponent implements OnInit {
  merchantGuids: Merchant[] = [];
  selectedMerchantGuid: string | undefined = undefined;
  @Input() config!: VccDailySummaryReportFilterResult;

  protected readonly currentDate = new Date();

  constructor(
    @Optional() public dialogRef: MatDialogRef<VccDailySummaryReportFilterModalComponent>,
    private mechantsService: MerchantsService,
  ) { }

  form: FormGroup = new FormGroup({
    releasedDate: new FormControl(null),
    merchantGuid: new FormControl(null)
  });

  handleClose() {
    if (!this.dialogRef) {
      return;
    }
    this.dialogRef.close(null);
  }

  ngOnInit() {
    this.mechantsService.merchants$.subscribe((merchants)=>{
      if (merchants) {
        this.merchantGuids = merchants;

        const { releasedDate, merchantGuid } = this.config ?? {};
        this.selectedMerchantGuid = merchantGuid ?? this.merchantGuids[0]?.merchantGuid;

        if (releasedDate === undefined) {
          let previousDate = new Date();
          previousDate.setDate(previousDate.getDate() - 1);
          this.config.releasedDate = previousDate.toJSON();
        }

        this.form.patchValue({
          releasedDate: this.config.releasedDate,
          merchantGuid: this.selectedMerchantGuid
        });
      }
    });
  }

  applyVccDailySummaryReportFilters() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    }
    else if (this.dialogRef) {
      this.config = this.form.value;
      this.dialogRef.close(this.config);
    }
  }


  getMerchantName() {
    this.selectedMerchantGuid = this.form.controls['merchantGuid'].value;
    const selectedMerchant = this.merchantGuids.find(merchant => merchant.merchantGuid === this.selectedMerchantGuid);
    return selectedMerchant ? selectedMerchant.fullName : this.merchantGuids[0].fullName;
  }
}
